import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ContentfulCardComponent } from "../components/contentful-card/contentful-card.component";
import { ContentfulWrapperComponent } from "../components/contentful-wrapper/container/contentful-wrapper.component";
import { WebinarDialogModule } from "./components/webinar-dialog/webinar-dialog.module";
import { WebinarsComponent } from "./container/webinars.component";

@NgModule({
  declarations: [WebinarsComponent],
  imports: [CommonModule, TranslateModule, ContentfulWrapperComponent, ContentfulCardComponent, WebinarDialogModule]
})
export class WebinarsModule {}
